export const truthyArrayItem = <T>(input: T | undefined) => !!input;
